import React, { useEffect, useRef } from "react"
import { Button, Grid, Typography } from "@material-ui/core"

import ErrorReportService from "@/services/ErrorReport"
import LetalkLogo from "@/components/SVGComponents/LetalkLogo"
import useStyles from "@/components/GlobalErrorBoundary/styles"

const MAX_RETRY_CLICKS = 3
export const STORAGE_KEY = "errorBoundaryRetryCount"

type FallbackScreenProps = {
	onReset: () => void
}

const FallbackScreen: React.FC<FallbackScreenProps> = (props) => {
	const { onReset } = props
	const classes = useStyles()
	const reported = useRef(false)

	const retryCount = Number(sessionStorage.getItem(STORAGE_KEY) ?? 0)
	const isRetryBlocked = retryCount >= MAX_RETRY_CLICKS

	useEffect(() => {
		if (reported.current) return
		reported.current = true
		ErrorReportService.report(window.location.pathname)
	}, [])

	const handleRetry = () => {
		if (isRetryBlocked) {
			window.location.href = "/"
			return
		}
		sessionStorage.setItem(STORAGE_KEY, String(retryCount + 1))
		onReset()
	}

	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			justifyContent="center"
			spacing={2}
			className={classes.container}
		>
			<Grid item>
				<LetalkLogo isDarkLogo className={classes.logo} />
			</Grid>

			<Grid item>
				<Typography variant="h5" className={classes.title}>
					Algo deu errado
				</Typography>
			</Grid>

			<Grid item>
				<Typography variant="body1" className={classes.subtitle}>
					Ocorreu um problema inesperado e a página não pôde ser carregada. Nossa equipe já foi notificada. Você pode tentar recarregar. Se o problema continuar, entre em contato com o suporte.
				</Typography>
			</Grid>

			<Grid item>
				<Button
					variant="contained"
					color="primary"
					onClick={handleRetry}
				>
					{isRetryBlocked ? "Ir para o início" : "Tentar novamente"}
				</Button>
			</Grid>
		</Grid>
	)
}

export default FallbackScreen
